// extracted by mini-css-extract-plugin
export var sidebar = "sidebar-module--sidebar--9099f";
export var spin = "sidebar-module--spin--ddef1";
export var title = "sidebar-module--title--ed9a3";